import { permissionChecks } from '../primary-navbar.helper';
import { userHasOnlyLicense } from 'cp-client-auth!sofe';
import { featureEnabled } from 'feature-toggles!sofe';

export const getGlobalPlusNavItems = (nav, betas = []) => {
  const transcriptsStandalone =
    featureEnabled('toggle_transcripts_module') && userHasOnlyLicense(nav.user, 'transcripts');
  return [
    {
      id: 'task',
      label: 'Create Task',
      icon: 'checkmark-circle-open-large',
      desc: 'Define a task to be completed.',
      action: () => nav.setOpenModal('task'),
      enabled: permissionChecks.canCreateTask(nav.user),
    },
    {
      id: 'contact',
      label: 'Add Contact',
      icon: 'person-add',
      desc: 'Create a contact.',
      action: () => nav.setOpenModal('contact'),
      enabled: permissionChecks.canCreateUser(nav.user) && !transcriptsStandalone,
    },
    {
      id: 'request',
      label: 'Client Request',
      icon: 'communication-paper-airplane',
      desc: 'Initiate a request for your client to complete.',
      action: () => createClientRequest(nav),
      enabled: permissionChecks.canCreateClientRequest(nav.user),
    },
    {
      id: 'email',
      label: 'Email',
      icon: 'communication-envelope',
      desc: 'Get a conversation started by sending a quick email.',
      action: () => nav.setOpenModal('email'),
      enabled: !permissionChecks.transcriptsOnly(nav.user),
    },
    {
      id: 'letter',
      label: 'Letter',
      icon: 'file-document',
      desc: 'Create a new or templated letter to send to your clients.',
      action: () => nav.setOpenModal('letter'),
      enabled: featureEnabled('ft_react_letters'),
    },
    {
      id: 'timeEntry',
      label: 'Time Entry',
      icon: 'misc-timer',
      desc: 'Add time spent to a task or client to better manage cost.',
      action: () => nav.setOpenModal('timeEntry'),
      enabled: permissionChecks.canAccessTime(nav.user),
    },
    {
      id: 'event',
      label: 'Calendar Event',
      icon: 'misc-calendar',
      desc: 'Create an event for your clients, team members or yourself.',
      action: () => nav.setOpenModal('event'),
      enabled: permissionChecks.canCreateEvent(nav.user),
    },
    {
      id: 'organizer',
      label: 'Tax Organizer',
      icon: 'misc-document-calculator',
      desc: 'Gather all the necessary files and information to prepare returns.',
      action: () => nav.setOpenModal('organizer'),
      enabled: permissionChecks.canCreateTaxReturn(nav.user),
    },
    {
      id: 'invoice',
      label: 'Invoice',
      icon: 'billing-invoice',
      desc: 'Generate an invoice and send it to your client via the Client Portal.',
      action: () => nav.setOpenModal('invoice'),
      enabled: permissionChecks.canCreateInvoice(nav.user),
    },
    {
      id: 'payment',
      label: 'Payment',
      icon: 'billing-credit-card',
      desc: 'Quickly make a payment on an invoice or account.',
      action: () => nav.setOpenModal('payment'),
      enabled: permissionChecks.canCreatePayment(nav.user),
    },
    {
      id: 'transcripts',
      label: 'Transcripts',
      icon: 'file-spreadsheet',
      desc: 'Quickly pull IRS transcripts and set up automatic pulls.',
      action: () => nav.setOpenModal('transcripts'),
      enabled: permissionChecks.canCreateTranscript(nav.user),
    },
    {
      id: 'notice',
      label: 'Notice',
      icon: 'communication-letter-front',
      desc: 'Create a workflow to manage and track your clients IRS notice.',
      action: () => nav.setOpenModal('notice'),
      enabled: permissionChecks.canCreateNotice(nav.user),
    },
  ];
};

const createClientRequest = nav => {
  if (!nav.dynamicLoadedModals.createClientRequest) {
    SystemJS.import('tasks-ui!sofe').then(tasks =>
      tasks.getClientRequestModal().then(res => {
        nav.loadDynamicModal('clientRequest', res);
      })
    );
  }
  nav.setOpenModal('clientRequest');
};
